module.exports = __webpack_public_path__ + "img/default.876ba58.png";